// extracted by extract-css-chunks-webpack-plugin
module.exports = {"news_box":"news_box-1mjznVaW clearfix","box_r":"box_r-1IBKpLm6","d_box":"d_box-3XrV_d97"};